import client from './client';
/**
 * Fetch all available skills from cosmo-core
 */
export const getAvailableSkills = async () => {
    const response = await client.get('/skills');
    return response.data;
};
/**
 * Fetch a specific skill by name
 */
export const getSkill = async (skillName) => {
    const response = await client.get(`/skills/${skillName}`);
    return response.data;
};
